function reporting() {
	const elId = '#app-reporting';
	const elClass = '.js-vue-reporting';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const headerHandicap = 1;

	Vue.component('select-report-item', {
		template: `
		<div>
			<p>{{data.Description}}</p>
			<br/>
			<div v-for="(el, i) in data.FilterParameters">	
				<div v-if="el.FilterValuesSQL != '' && el.FilterValuesSQL != null">
					{{el.DisplayName}}
					<select v-model="params[i]">						
						<option :value="''" disabled>--select option--</option>
						<option v-for="(opt, j) in getValues(el.ParamName)" :value="opt.key">{{opt.value}}</option>
					</select>
				</div>
				<div v-else>
					<nominow-input-text v-model="params[i]" 
						:name="el.ParamName" 
						:label="el.DisplayName" 
						:required="!el.IsNullable" 					
						:css="el.ParamType == 'System.DateTime' ? 'datepicker js-datepicker' : null"
						></nominow-input-text>
				</div>				
			</div>
			<br/>
			<div>
				<button class="button is-primary" v-on:click="executeReport">Get Report</button>
				<span v-if="!data.IsDirectReport" class="button is-clean has-no-pointer has-text-info is-italic">This report request will be placed in the queue</span>
			</div>

		</div>
		`,
		props: {
			data: {
				type: Object,
				required: true
			}
		},
		data: function() {
			return {
				params: [],
				selectValues: {}
			};
		},
		created: function() {
			const self = this;
			if (this.data.FilterParameters) {
				for (let i = 0; i < this.data.FilterParameters.length; i++) {
					self.params[i] = '';
					const param = this.data.FilterParameters[i];
					if (param.FilterValuesSQL) {
						const name = param.ParamName;
						GET(param.FilterValuesSQL).then(xhr => {
							const result = JSON.parse(xhr.responseText);
							Vue.set(self.selectValues, name, result);
						});
					}
				}
			}
		},
		mounted: function() {
			window.initDatepicker();
			$('input:first', this.$el).focus();
		},
		methods: {
			executeReport: function() {
				toggleLoader(true);
				const self = this;
				const reportParameters = {};
				for (let i = 0; i < this.data.FilterParameters.length; i++) {
					reportParameters[this.data.FilterParameters[i].ParamName] = this.params[i];
				}
				const params = {
					reportGuid: this.data.ReportInfoId,
					userGuid: window.nominowUserguid,
					parameters: reportParameters
				};
				POST('/baas/nominow_reporting/report', params, 100000)
					.then(xhr => {
						const response = JSON.parse(xhr.responseText);
						toggleLoader(false);
						if (response.status) {
							if (response.type == 'direct') {
								window.openb64FileDownload(response.fileContent, response.filename, 'text/plain');
								self.$parent.closemodals();
							} else {
								window.initToast('Report succesfully queued', 'success');
								self.$parent.closemodals();
							}
						} else if (response.Message) {
							window.initToast(response.Message, 'error');
						} else {
							window.initToast(xhr.responseText, 'error');
						}
					})
					.catch(xhr => {
						toggleLoader(false);
						window.initToast(xhr.responseText, 'error');
					});
			},
			getValues: function(name) {
				const items = this.selectValues[name];
				return items;
			}
		}
	});

	const app = new Vue({
		el: elId,
		data: {
			search: {
				field: null,
				currentkeyword: null
			},
			fullReports: [],
			reports: [],
			pagination: {
				max: 999,
				pagesize: 10,
				currentpage: 0
			},
			componentmodal: null,
			error: null
		},
		created: function() {
			const self = this;
			GET('/baas/Nominow_Reporting/reports')
				.then(xhr => {
					self.error = null;
					const response = JSON.parse(xhr.responseText);
					self.fullReports = response;
					const queue = Array.prototype.map.call(response, el => ({
						Name: el.ReportName,
						Description: el.Description
					}));
					queue.splice(0, 0, {
						Name: 100,
						Description: 200
					});
					self.reports = queue;
					$(elClass).removeClass('is-creating');
				})
				.catch(xhr => {
					self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
					$(elClass).removeClass('is-creating');
				});
		},
		mounted: function() {
			$(elClass).removeClass('is-mounting');
		},
		methods: {
			selectItem: function(item, ix) {
				const report = this.fullReports[ix + this.pagination.currentpage * this.pagination.pagesize];
				this.componentmodal = {
					title: report.ReportName,
					component: 'select-report-item',
					data: report
				};
			},
			closemodals: function() {
				this.componentmodal = null;
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
reporting();
